<template>
  <div class="our-strengths" :style="ourstrengths.isGrey ? 'background: #fafafa': ''">
    <div class="page-container">
      <div class="header">
        <div class="title">
          {{ourstrengths.title}}
        </div>
        <div class="sub-title" v-if='ourstrengths.subtitle'>
          {{ourstrengths.subtitle}}
        </div>
      </div>
      <div class="content">
        <div class="strengths-card" v-for="(item, index) in ourstrengths.content" :key="index">
          <div class="top">
            {{item.title}}
          </div>
          <div class="bottom">
            <div>
              <img :src="item.img" alt="">
            </div>
            <div class="intro">
              {{item.intro}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    ourstrengths: {
      type: Object,
      default: () => {
        return {
          title: '我们的优势',
          subtitle: '沉浸式教学体验，还原真实课堂',
          content: [{
            title: '录制回放',
            intro: '平台提供两种录制功能，可生成直播录制视频及云端回放链接。沉淀优质教学内容。',
            img: require('@/assets/introduce/paas1-image3.png')
          },{
            title: '录制回放',
            intro: '平台提供两种录制功能，可生成直播录制视频及云端回放链接。沉淀优质教学内容。',
            img: require('@/assets/introduce/paas1-image3.png')
          },{
            title: '录制回放',
            intro: '平台提供两种录制功能，可生成直播录制视频及云端回放链接。沉淀优质教学内容。',
            img: require('@/assets/introduce/paas1-image3.png')
          },{
            title: '录制回放',
            intro: '平台提供两种录制功能，可生成直播录制视频及云端回放链接。沉淀优质教学内容。',
            img: require('@/assets/introduce/paas1-image3.png')
          },]
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
.our-strengths {
.content {
  display: flex;
  justify-content: space-between;
  .strengths-card {
    width: 280px;
    height: 360px;
    opacity: 1;
    background: #fcfdff;
    border-radius: 10px;
    box-shadow: 0px 0px 4px 0px rgba(201,218,231,0.50);
    overflow: hidden;
    margin-top: 30px;
    .top {
      height: 83px;
      opacity: 1;
      text-align: center;
      font-weight: 600;
      color: #ffffff;
      font-size: 21px;
      line-height: 83px;
      background: linear-gradient(325deg,#3b71f2 7%, #8da8ff 95%);
    }
    .bottom {
      padding: 30px 25px 0;
      text-align: center;
      > div:first-child {
        width: 100px;
        height: 100px;
        opacity: 1;
        background: #f6f8ff;
        border-radius: 50%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        width: 60px;
        height: 60px;
      }
      .intro {
        text-align: left;
        font-size: 16px;
        color: #666666;
        line-height: 25px;
        margin-top: 25px;
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }

    }
  }
}
}
</style>
